<template>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>货品列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">
            <el-button type="success" v-if="!order.status" @click="showAdd()">
              <el-icon><plus /></el-icon>添加油品
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  <el-table :data="details" border>
    <el-table-column type="index" label="序号"></el-table-column>
    <!--
    <el-table-column label="图片">
      <template #default="scope">
        <img :src="$utils.imageSrc(scope.row.pic)"/>
      </template>
    </el-table-column>
    -->
    <el-table-column prop="name" label="名称"></el-table-column>
    <el-table-column label="类型">
      <template #default="scope">
        {{scope.row.type === 0 ? '油品' : '物料'}}
      </template>
    </el-table-column>
    <el-table-column label="数量">
      <template #default="scope">
        <el-input type="number" v-model="scope.row.quantity" @change="handleNumChange(scope.$index)" :readonly="order.status || scope.row.type !== 0" placeholder="请输入数量">
          <template #append>{{scope.row.unit}}</template>
        </el-input>
      </template>
    </el-table-column>
    <el-table-column label="操作" v-if="!order.status">
      <template #default="scope">
        <el-link type="danger" href="javascript:;" :disabled="scope.row.type !== 0" @click="del(scope.$index, scope.row)">删除</el-link>
      </template>
    </el-table-column>
  </el-table>
  </div>
  <el-button type="primary" v-if="!order.status" @click="confirmOrder" style="margin-top: 12px;">确认</el-button>

  <el-dialog title="添加油品" v-model="addVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="oil" ref="oil">
      <el-form-item label="油品" label-width="78px">
        <el-select v-model="currentOil" value-key="sn">
          <el-option v-for="(item, index) in oils" :key="index" :label="item.name" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数量" label-width="78px">
        <el-input type="number" v-model="oil.quantity" placeholder="请输入数量">
          <template #append>{{currentOil.unit ? currentOil.unit : '箱'}}</template>
        </el-input>
      </el-form-item>
      <el-button type="primary" @click="add">确定</el-button>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "门店首单",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      shopSn: null,
      order: {},
      details: [],
      oils: [],
      addVisible: false,
      oil: {},
      currentOil: {}
    }
  },
  methods: {
    get() {
      this.$apis.store.shopFirst(this.shopSn).then(response => {
        const order = response.data.data[0]
        this.order = {orderNo: order.orderNo, status: order.status}
        this.details = order.factoryOrderItemVOS
      })
    },
    showAdd() {
      this.addVisible = true
      this.oil = {}
      this.currentOil = {}
    },
    add() {
      if (!this.currentOil || !this.currentOil.sn) {
        this.$message.error('请选择油品')
        return
      }
      if (!this.oil.quantity) {
        this.$message.error('请输入数量')
        return
      }
      this.oil.goodsSn = this.currentOil.sn
      this.oil.pic = this.currentOil.pic
      this.oil.name = this.currentOil.name
      this.oil.type = this.currentOil.type
      this.oil.unit = this.currentOil.baseUnit
      const total = this.details.reduce((total, item) => total + (item.type === 0 ? Number(item.quantity) : 0), 0)
      if (total + Number(this.oil.quantity) > 10) {
        this.$message.error('油品总数量不能大于10')
        return
      }
      const index = this.details.findIndex(item => item.goodsSn === this.oil.goodsSn)
      if (index >= 0) {
        this.details[index].quantity = Number(this.details[index].quantity) + Number(this.oil.quantity)
      } else {
        this.details.unshift(this.oil)
      }
      this.addVisible = false
    },
    del(index, oil) {
      this.$confirm('确认删除【' + oil.name + '】？', '删除确认',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        this.details.splice(index, 1)
      }).catch(() => {

      })
    },
    confirmOrder() {
      this.order.factoryOrderItemTOS = []
      this.details.forEach(item => {
        this.order.factoryOrderItemTOS.push({
          goodsSn: item.goodsSn,
          quantity: item.quantity
        })
      })
      this.$apis.store.confirmShopFirst(this.order).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.get()
        }
      })
    },
    handleNumChange(index) {
      if (Number(this.details[index].quantity) <= 0) {
        this.details[index].quantity = 1
        return
      }
      const total = this.details.reduce((total, item) => total + (item.type === 0 ? Number(item.quantity) : 0), 0)
      if (total > 10) {
        this.$message.error('油品总数量不能大于10')
        this.details[index].quantity = 10 - this.details.reduce((total, item) =>
            total + (item.type === 0 && item.goodsSn !== this.details[index].goodsSn ? Number(item.quantity) : 0), 0)
      }
    }
  },
  created() {
    this.shopSn = this.$route.query.sn
    this.get()
    this.$apis.storeGoods.list(0, 99, {type: 0}).then(response => {
      this.oils = response.data.data
    })
  }
}
</script>

<style scoped>

</style>